export const STAFF_HOLIDAY_PERMISSIONS = {
  ADMIN: "Super Holiday Admin",
  MANAGER: "Holiday Admin",
};

export const LEAVE_TYPES = {
  ANNUAL_LEAVE: "annual_leave",
  SICK_LEAVE: "sick_leave",
  UNPAID_LEAVE: "unpaid_leave",
  PAID_LEAVE: "paid_leave",
  COMPASSIONATE_LEAVE: "compassionate_leave",
  PARENTAL_LEAVE: "parental_leave",
  LIEU: "lieu",
  TIME_OFF_IN_LIEU: "lieu",
  AWOL: "awol",
  // OTHER: "other",
  // OTHER_LEAVE: "other",
};

export const LEAVE_TYPE_LABELS = {
  [LEAVE_TYPES.ANNUAL_LEAVE]: "Annual Leave",
  // [LEAVE_TYPES.SICK_LEAVE]: "Sick Leave",
  [LEAVE_TYPES.UNPAID_LEAVE]: "Unpaid Leave",
  // [LEAVE_TYPES.PAID_LEAVE]: "Paid Leave",
  // [LEAVE_TYPES.LIEU]: "Time Off In Lieu",
  // [LEAVE_TYPES.OTHER]: "Other Leave",
};
export const ADMIN_LEAVE_TYPE_LABELS = {
  [LEAVE_TYPES.ANNUAL_LEAVE]: "Annual Leave",
  [LEAVE_TYPES.AWOL]: "AWOL (Absence Without Leave)",
  [LEAVE_TYPES.COMPASSIONATE_LEAVE]: "Compassionate Leave",
  // [LEAVE_TYPES.OTHER]: "Other Leave",
  // [LEAVE_TYPES.PAID_LEAVE]: "Paid Leave",
  [LEAVE_TYPES.PARENTAL_LEAVE]: "Parental Leave",
  [LEAVE_TYPES.SICK_LEAVE]: "Sick Leave",
  [LEAVE_TYPES.LIEU]: "Time Off In Lieu",
  [LEAVE_TYPES.UNPAID_LEAVE]: "Unpaid Leave",
};

export const LEAVE_STATUS = {
  PENDING_MANAGER: "pending_manager",
  PENDING_ADMIN: "pending_admin",
  APPROVED: "approved",
  REJECTED: "rejected",
  CANCELLED: "cancelled",
};

export const LEAVE_STATUS_LABELS = {
  pending_manager: "Pending",
  pending_holiday_manager: "Pending",
  pending_admin: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  cancelled: "Cancelled",
};

export const DAY_TYPES = {
  FULL: "full",
  MORNING: "morning",
  AFTERNOON: "afternoon",
};

export const MANAGER_APPROVAL_POLICY = {
  ANY_ONE: "any_one",
  ALL_REQUIRED: "all_required",
};

export const BANK_HOLIDAY_REGIONS = {
  ENGLAND_AND_WALES: "england-and-wales",
  SCOTLAND: "scotland",
  NORTHERN_IRELAND: "northern-ireland",
};

export const EXCEL_LEAVE_CODE_MAP = {
  1: LEAVE_TYPES.ANNUAL_LEAVE,
  1: LEAVE_TYPES.ANNUAL_LEAVE,
  S: LEAVE_TYPES.SICK_LEAVE,
  s: LEAVE_TYPES.SICK_LEAVE,
  UL: LEAVE_TYPES.UNPAID_LEAVE,
  ul: LEAVE_TYPES.UNPAID_LEAVE,
  PL: LEAVE_TYPES.PAID_LEAVE,
  pl: LEAVE_TYPES.PAID_LEAVE,
};
